module.exports = __webpack_public_path__ + "img/masas-artesanales-maquina.459aa656.jpeg";